@if(data.title) {
  <h2 mat-dialog-title>{{ data.title | translate }}</h2>
}

<mat-dialog-content>
  @if(data.dialogContent){
    <ng-container [ngTemplateOutlet]="data.dialogContent" ></ng-container>
  } @else {
    @if(data.iconSvg) {
      <mat-icon class="app-dialog-icon" [svgIcon]="data.iconSvg"></mat-icon>
    }
    <span [innerHTML]="data.body | translate"></span>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if(data.dialogActions){
    <ng-container [ngTemplateOutlet]="data.dialogActions" ></ng-container>
  } @else {
    <button
      mat-button
      [color]="data.yesBtnColor || null"
      class="app-dialog-yes-btn"
      [mat-dialog-close]="true"
    >
      {{ data.yesBtnText || "YES" | translate }}
    </button>

    @if (data.confirmation) {
      <button
        mat-button
        [color]="data.noBtnColor || null"
        class="app-dialog-no-btn"
        [mat-dialog-close]="false"
      >
        {{ data.noBtnText || "NO" | translate }}
      </button>
    }
  }
</mat-dialog-actions>
